// src/App.js
import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { UserDataProvider, UserDataContext } from './context/UserDataContext';
import CrownMatchGame from './components/CrownMatchGame';
import WigJeopardy from './components/WigJeopardy';
import ColorSwatches from './components/ColorIndex';
import BossCrownsColorIndexManager from './components/BossCrownsColorIndexManager';
import CreateGame from './components/Bingo/CreateGame';
import JoinGame from './components/Bingo/JoinGame';
import GameMaster from './components/Bingo/GameMaster';
import Player from './components/Bingo/Player';
import CustomAppBar from './components/CustomAppBar';
import './App.css';
import { BingoUserDataProvider } from './context/BingoUserDataContext';
import { TriviaUserDataProvider } from './context/TriviaUserDataContext';

import TriviaGameMaster from './components/Trivia/TriviaGameMaster';
import TriviaPlayer from './components/Trivia/TriviaPlayer';
import CreateTriviaSession from './components/Trivia/CreateTriviaSession';
import JoinTriviaSession from './components/Trivia/JoinTriviaSession';

// ProtectedRoute component to restrict access to admin-only routes
const ProtectedRoute = ({ children }) => {
  const { userData } = React.useContext(UserDataContext);
  const isAdmin = userData?.role === 'admin'; // Adjust based on your UserDataContext structure
  if (!isAdmin) {
    return <Navigate to="/bingo/join" />;
  }
  return children;
};

function App() {
  return (
    <TriviaUserDataProvider>
        <BingoUserDataProvider>
    <UserDataProvider>
      <HashRouter>
        <div className="App">
          <CustomAppBar />
          <Routes>
            <Route path="/jeopardy" element={<WigJeopardy />} />
            <Route path="/match-game" element={<CrownMatchGame />} />
            <Route path="/color-index" element={<ColorSwatches />} />
            <Route path="/color-index-manager" element={<BossCrownsColorIndexManager />} />
            <Route path="/bingo/create" element={<CreateGame />} />
            <Route path="/bingo/join" element={<JoinGame />} />
            <Route path="/bingo/game-master/:pin" element={<GameMaster />} />
            <Route path="/bingo/player/:pin" element={<Player />} />
            <Route path="/" element={<CrownMatchGame />} />
            <Route path="/trivia/create" element={<CreateTriviaSession />} />
        <Route path="/trivia/game-master/:pin" element={<TriviaGameMaster />} />
        <Route path="/trivia/join" element={<JoinTriviaSession />} />
        <Route path="/trivia/player/:pin" element={<TriviaPlayer />} />
          </Routes>
        </div>
      </HashRouter>
    </UserDataProvider>
    </BingoUserDataProvider>
    </TriviaUserDataProvider>
  );
}

export default App;